import {useCallback} from 'react';
import {safeCaptureException} from '../../../utils';
import {useS3Upload} from '../../s3Upload/useS3Upload';

type UseLivenessVideoUploadProps = {
  uploadFile: ReturnType<typeof useS3Upload>['uploadFile'];
  onUploadFinished: (value: string) => void;
};

function useLivenessVideoUpload({
  uploadFile,
  onUploadFinished,
}: UseLivenessVideoUploadProps) {
  const uploadLivenessVideo = useCallback(
    async (recordingVideo?: Blob | null): Promise<string | undefined> => {
      if (!recordingVideo) return undefined;

      try {
        const videoFile = new File([recordingVideo], 'liveness-video.mp4', {
          type: 'video/mp4',
        });

        const {data, error} = await uploadFile(videoFile, {
          contentType: 'video/mp4',
        });

        if (data) {
          onUploadFinished(data.key);
          return data.key;
        }

        if (error) {
          console.error(error);
          onUploadFinished('ERROR_UPLOADING_VIDEO');
        }
      } catch (error) {
        safeCaptureException(error, 'Document selfie detection error');
        console.error('Document selfie detection error:', error);
      }

      return undefined;
    },
    [onUploadFinished, uploadFile],
  );

  return {uploadLivenessVideo};
}

export {useLivenessVideoUpload};
